import { Metrics } from './metrics';

// only expected to be unknown in jest
let packageName = 'unknown';
let templateBasename = 'unknown';

try {
  templateBasename =
    (window as any)?.hubspot?.bender?.templateBasename ?? 'unknown';
} catch (e) {
  /* ignore */
}

try {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  packageName = require('current-package-loader!').name;
} catch (e) {
  // ignore
}

let hasSeenReady = false;

const baseDimensions = {
  packageName,
  templateBasename,
} as const;

function createMetrics() {
  const currentDimensions = {
    ...baseDimensions,
    hasSeenReady: `${hasSeenReady}`,
  };

  return {
    true: Metrics.counter('foundations-theme-ready', {
      ...currentDimensions,
      result: 'true',
    }),
    false: Metrics.counter('foundations-theme-ready', {
      ...currentDimensions,
      result: 'false',
    }),
  };
}

let metrics = createMetrics();

/**
 * Emit metrics to help find places where apps aren't properly configured
 */
export function emitFoundationsReadinessTracking(themeMissing: boolean) {
  try {
    if (!themeMissing && !hasSeenReady) {
      hasSeenReady = true;
      metrics = createMetrics();
    }

    (themeMissing ? metrics.false : metrics.true).increment();
  } catch {
    // It's fine, this is very best effort,
    // we just don't want to ever crash an app.
  }
}
